module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//12.jpg?c5a530ad46134322ce048e4733bd05a4";